/** @format */

module.exports = [];



// WEBPACK FOOTER //
// ./src/partners/config/variants.js